import "./ProtocolTable.css"

const ProtocolTable = ({ data }) => {
  if (!data) return null

  return (
    <div className="protocol-table-container">
      <div className="protocol-header">
        <h3 className="protocol-header-title">
          HEART DISEASE PREVENTION - AI RECOMMENDED PROTOCOL (FOR DR REVIEW & ADVISE)
        </h3>
      </div>
      <table className="protocol-table">
        <tbody>
          <tr>
            <td className="protocol-category">LAB INVESTIGATION</td>
            <td className="protocol-details">
              {data.labInvestigationRecommended && Object.keys(data.labInvestigationRecommended).length > 0 ? (
                <div>
                  {Object.entries(data.labInvestigationRecommended)
                    .filter(([_, value]) => value === "Yes")
                    .map(([key], index) => (
                      <span key={index}>
                        {key}
                        {index <
                        Object.entries(data.labInvestigationRecommended).filter(([_, v]) => v === "Yes").length - 1
                          ? ", "
                          : ""}
                      </span>
                    ))}
                </div>
              ) : (
                "No specific lab investigations recommended"
              )}
            </td>
          </tr>
          <tr>
            <td className="protocol-category">DIAGNOSTICS AND IMAGING</td>
            <td className="protocol-details">
              {data.diagnosticsAndImagingRecommended &&
              Object.keys(data.diagnosticsAndImagingRecommended).length > 0 ? (
                <div>
                  {Object.entries(data.diagnosticsAndImagingRecommended)
                    .filter(([_, value]) => value === "Yes")
                    .map(([key], index) => (
                      <span key={index}>
                        {key}
                        {index <
                        Object.entries(data.diagnosticsAndImagingRecommended).filter(([_, v]) => v === "Yes").length - 1
                          ? ", "
                          : ""}
                      </span>
                    ))}
                </div>
              ) : (
                "No specific diagnostics or imaging recommended"
              )}
            </td>
          </tr>
          <tr>
            <td className="protocol-category">MEDICATION</td>
            <td className="protocol-details">
              {data.medication && data.medication.GeneralTreatment
                ? data.medication.GeneralTreatment
                : "General Treatment"}
            </td>
          </tr>
          <tr>
            <td className="protocol-category">REFERRAL</td>
            <td className="protocol-details">
              {data.department
                ? `${data.department} Referral ${data.urgency || ""}`
                : "No specific referral recommended"}
            </td>
          </tr>
          <tr>
            <td className="protocol-category">TREATMENT GOALS</td>
            <td className="protocol-details">
              {data.treatment_goals && data.treatment_goals.length > 0 ? (
                <div className="treatment-goals">
                  {data.treatment_goals.map((goal, index) => (
                    <div key={index} className="treatment-goal">
                      <strong>{goal.heading}: </strong>
                      <span>{goal.description}</span>
                    </div>
                  ))}
                </div>
              ) : (
                "No specific treatment goals recommended"
              )}
            </td>
          </tr>
          <tr>
            <td className="protocol-category">ADVICE</td>
            <td className="protocol-details">
              {data.advice || "EDUCATE on lifestyle management and Smoking or Tobacco Use Cessation."}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default ProtocolTable

